import { IStateTag, TDefinitionKey } from '../../actions/filterTags/definitionFactory';

export function equalTagKey(key: TDefinitionKey) {
  return ({ keyName }: IStateTag) => keyName === key;
}
